module.exports = __webpack_public_path__ + "static/img/contentus.09da254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/contentus.jpg
// module id = wd3Q
// module chunks = 0